import { withInstall } from '@ll-plus/utils'

import CronExpressionBuilder from './src/cron-expression-builder.vue'

export const LlCronExpressionBuilder = withInstall(CronExpressionBuilder)
export default LlCronExpressionBuilder
export * from './src/config'
declare module 'vue' {
  export interface GlobalComponents {
    LlCronExpressionBuilder: typeof CronExpressionBuilder
  }
}
